var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommercial({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.54 13.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #8b8c9e;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "2.31 4.04 2.31 13.47 18.24 13.47 18.24 4.02"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.56,
    y: 7.58,
    width: 2.93,
    height: 5.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.71,
    y: 7.58,
    width: 6.27,
    height: 3.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.5,4.77c1.22,0,1.22-.75,2.43-.75s1.22,.75,2.44,.75,1.22-.75,2.44-.75,1.22,.75,2.44,.75,1.22-.75,2.45-.75,1.22,.75,2.44,.75,1.22-.75,2.45-.75,1.23,.75,2.45,.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: ".5 4.52 .5 .5 20.04 .5 20.04 4.77"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercial);
export default __webpack_public_path__ + "static/media/commercial.966d6224.svg";
export { ForwardRef as ReactComponent };